import {callApi} from '@/lib/api/callApi';
import _ from 'lodash';

/**
 * 取得省
 * @returns {Promise} promise
 */
const getProvince = _.memoize(async function () {
  const res = await callApi({
    category: 'province',
    apiName: '',
    method: 'get',
    defaultError: null,
  });
  return res.data;
});

/**
 * 取得地級行政區
 * @param {String} id 省id
 * @returns {Promise} promise
 */
const getCities = _.memoize(async function (id = 1) {
  const res = await callApi({
    category: 'province',
    apiName: `${id}/cities`,
    method: 'get',
    defaultError: null,
  });
  return res.data;
});

/**
 * 取得縣級行政區
 * @param {String} id 省id
 * @param {String} cityId 地級行政區id
 * @returns {Promise} promise
 */
async function getDistricts(id = 1, cityId) {
  const res = await callApi({
    category: 'province',
    apiName: `${id}/cities/${cityId}/districts`,
    method: 'get',
  });
  return res.data;
}

/**
 * 取得省
 * @returns {Promise} promise
 */
const getProvinceRankType = _.memoize(async function (provinceId) {
  const res = await callApi({
    category: 'province',
    apiName: `/${provinceId}/rank-types`,
    method: 'get',
    defaultError: null,
  });
  return res.data;
});

export default {
  getProvinceRankType,
  getProvince,
  getCities,
  getDistricts,
};
